<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-if="theUserProject==0" v-model='theProjectId' @change="theProjectAllChange" size="small" clearable placeholder="请选择项目">
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
        <el-select v-model='thePostId' clearable placeholder='请选择岗位' size='small' @change="postChange">
          <el-option
              v-for="item in postAll"
              :key="item.postId"
              :label="item.postName"
              :value="item.postId">
            </el-option>
        </el-select>
        <el-select v-model='ycDelete' clearable placeholder='请选择状态' size='small' @change="ycDeleteChange">
          <el-option
              v-for="item in ycDeleteAll"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
        </el-select>
        <el-input
          v-model="getUserOfficialList_data.userName"
          placeholder="请输入用户名"
          clearable
          size='small'
          style="max-width:260px;margin-left:10px;" />
        <el-input
          v-model="getUserOfficialList_data.userPhone"
          placeholder="请输入手机号"
          clearable
          size='small'
          style="max-width:260px;margin-left:10px;" />

        <el-button
          v-click.getUserOfficialList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
    </el-row>
    
    <mytable
      :tableColums='tableColums_getUserOfficialList'
      api='getUserOfficialList'
      xupdateapi='updateUser'
      :height="H-165" >
    </mytable> 
    <el-dialog title="项目列表" :visible.sync="isProjectShow" width="70%" :before-close="ProjectListClose"
      style="margin-left: 200px;">
      <el-table ref="projectTable" :data="projectdata" stripe border style="width: 100%" max-height="500px"
          :cell-style="{ textAlign: 'center' }" :header-cell-style="{
            textAlign: 'center',
            background: 'rgba(0,170,255,0.5)',
            color: 'black',
            border: 'none'
          }">
          <el-table-column type="index" width="50" fixed="left" label="序号">
          </el-table-column>
          <el-table-column prop="projectName" label="项目名称" fixed="left">
          </el-table-column>
          <el-table-column prop="projectRemark" label="项目描述">
          </el-table-column>
      </el-table>
    </el-dialog>
    <myform view.getDataUserDetails='用户详情'
      @opened='arguments[0].title += " | @" + row.userName'>
      <div v-if='dataUserDetailsAll'>
        <!-- <div>姓名 :  {{dataUserDetails.userName}}</div>
        <div>岗位名称 : {{dataUserDetails.postId}}</div> -->
        <el-avatar size="small" :src="dataUserDetails.userHeader"></el-avatar>
        <div>用户项目 :  </div>
        <el-card v-for="item in dataUserProjectDetails" :key="item.puId" >
          项目名称 : {{item.projectName}}
          加入时间 : {{item.createtime}}
          <div>所属战队 ：{{item.dtName}}</div>
          <div>目标走访数量 ：{{item.userVisitorTargetCount}}</div>
          <div>目标签单金额 ：{{item.userOrderMoneyTarget}}</div>
        </el-card>
      </div>
      <hide slot='userId' />
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      projectdata:[],
      isProjectShow:false,
      userId: null,
      theProjectId:"",
      theUserProject:"",
      row:{},
      dataUserDetailsAll:{},
      dataUserDetails:{},
      dataUserProjectDetails:{},
      thePostId:"",
      postAll:[
        {postId:1,postName:"平台"},
        {postId:2,postName:"战队管理"},
        {postId:3,postName:"项目经理"},
        {postId:4,postName:"老师"},
        {postId:5,postName:"学员"},
        {postId:6,postName:"项目管理员"}
      ],
      ycDelete:1,
      ycDeleteAll:[
        {id:1,name:"正常"},
        {id:2,name:"已删除"},
        {id:3,name:"已封号"},
        {id:4,name:"已注销"}
      ],
      theYutId:"",
      tableColums_getUserOfficialList: {
        $selection: false,

        userName: '用户名',
        userAccount: '工号',
        userPhone: '手机号',
        postId: [ '岗位', , '@v-if: 1:平台管理, 2:战队管理, 3:项目经理, 4:老师, 5:学员, 6:项目管理员' ],
        yutName:'类型',
        roleNames: '角色',
        // userVisitorTargetCount: ['每日走访目标',,
        //   this.updateUserVisitorTargetCount && `@text: {{ $row.userVisitorTargetCount + ' 设置' }}#success
        //     @click: $form("updateUserVisitorTargetCount",$row)
        //     `,
        // ],
        // userOrderMoneyTarget: ['每日开单金额目标',,
        //   this.updateUserOrderMoneyTarget && `@text: {{ $row.userOrderMoneyTarget + ' 设置' }}#success
        //     @click: $form("updateUserOrderMoneyTarget",$row)
        //     `,
        // ],
        loginLastTime: '最后活跃时间',
        createtime: '创建时间|sortable',
        userRemark: [ "账号描述", 120 ],
        $operation: ( this.updateUser || this.deleteUser ) && [
          '操作', 260,
          this.getDataUserDetails && `@text: 详情#success
           @click: toGetDataUserDetails($row)
          `,
          this.deleteUser && `@text: 禁用#danger
           @click: _confirm('确定要禁用该账号吗?')
                   .trigger('deleteUserStatusThree',{userId:$row.userId})
                   .trigger('getUserOfficialList')
          `,
          this.deleteUser && `@text: 删除#danger
           @click: _confirm('确定要删除该账号吗?')
                   .trigger('deleteUserStatus',{userId:$row.userId})
                   .trigger('getUserOfficialList')
          `,
          this.resetUserPassword && `@text: 重置密码#danger
           @click: _confirm('确定要重置该账号密码吗?')
                   .trigger('resetUserPassword',{userId:$row.userId})
                   .trigger('getUserOfficialList')
          `,
          this.getUserProjectListAll && `@text: 所有项目#success
           @click: handleProjectList($row)
          `,

        ],

      },

    };
  },

  watch: {
    
  },

  methods: {
    ProjectListClose(){
      this.isProjectShow = false;
    },
    handleProjectList(row){
      var that = this;
      that.getUserProjectListAll({userId:row.userId}).result(res =>{
        that.projectdata = res.data.data;
        that.isProjectShow = true
      })
    },
    toGetDataUserDetails(row){
      this.$form("getDataUserDetails", this.row = row)
      this.getDataUserDetails({userId:row.userId}).result(res=>{
        this.dataUserDetailsAll=res;
        this.dataUserDetails=res.data.data.user;
        this.dataUserProjectDetails=res.data.data.projectUserList;
      })
    },
    theProjectAllChange(e){
      this.theProjectId=e;
      this.getData();
    },
    yutChange(e){
      this.theYutId=e;
      this.getData();
    },
    postChange(e){
      this.thePostId=e;
      this.getData();
    },
    ycDeleteChange(e){
      this.ycDelete=e;
      this.getData();
    },
    getData(){
        if(this.theProjectId==0){
            this.theProjectId=null;
        }
        this.getUserOfficialList(
          {currentPage:1,
            pageSize:10,
            projectId:this.theProjectId,
            postId:this.thePostId,
            yutId:this.theYutId,
            ycDelete:this.ycDelete
          }
        );
    }
  },

  created() {
    this.theUserProject=A.local('$projectId');
    if(this.theUserProject==0){
      this.getProjectList({pageSize:0});
    }else{
      this.theProjectId=this.theUserProject;
    }
    this.getData();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/data/DataOfficialUser.vue